module.exports = __webpack_public_path__ + "web-assets/img/bg.229f4f05.png";